import { Component, Input } from '@angular/core';
import { JuvenileCase } from './../../../juvenile/juvenile-case';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./../juvenile-case-view.component.less']
})
export class EventsComponent implements OnInit {
  relatedAllegationsFlag: boolean;

@Input() juvenileCase: JuvenileCase;

showAdditionalEventsInfoFlags = [];

  constructor() { 
//    this.relatedAllegationsFlag = false;
  }

// getRelatedAllegationsFlag(): boolean {
//     return this.relatedAllegationsFlag;
// }

// showReleatedAllegations() {
//     this.relatedAllegationsFlag = true;
// }

// hideReleatedAllegations() {
//     this.relatedAllegationsFlag = false;
// }

ngOnInit() {
  if (this.juvenileCase && this.juvenileCase.getEventList()) {
    this.showAdditionalEventsInfoFlags = new Array(this.juvenileCase.getEventList().length).fill(false);
  }
}

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/events/events.component.ts